// Ball Sort palette — colors a–h as rendered by the original inline <defs>.
// All entries are plain radial gradients (no checker fills).

import type { Palette } from "../shared-sortaballs/types"

export const PALETTE: Palette = {
	a: { className: "bs-col--a", color: "var(--ball-a)", type: "gradient" },
	b: { className: "bs-col--b", color: "var(--ball-b)", type: "gradient" },
	c: { className: "bs-col--c", color: "var(--ball-c)", type: "gradient" },
	d: { className: "bs-col--d", color: "var(--ball-d)", type: "gradient" },
	e: { className: "bs-col--e", color: "var(--ball-e)", type: "gradient" },
	f: { className: "bs-col--f", color: "var(--ball-f)", type: "gradient" },
	g: { className: "bs-col--g", color: "var(--ball-g)", type: "gradient" },
	h: { className: "bs-col--h", color: "var(--ball-h)", type: "gradient" },
}
